// extracted by mini-css-extract-plugin
module.exports = {"question":"Style_question__1INqw","onTopBtn":"Style_onTopBtn__1a_J7"};